module.exports = __webpack_public_path__ + "static/vft-projeto_r-e0b40865015465526b2653f55eaa8721.jpg";